import { useEffect, useRef, RefObject } from 'react';
import useCallsStore, { CallsStoreState } from './useCallsStore';

const useCallsStoreRef = <K extends keyof CallsStoreState>(key: K): RefObject<CallsStoreState[K]> => {
  const ref = useRef<CallsStoreState[K]>(useCallsStore.getState()[key]);

  useEffect(() => {
    const unsubscribe = useCallsStore.subscribe(
      (state) => state[key],
      (value) => {
        ref.current = value;
      },
    );
    return () => unsubscribe();
  }, [key]);

  return ref;
};

export default useCallsStoreRef;
